import {APIError} from 'data/errors/api-error';
import {HttpClient, HttpStatusCode} from 'data/protocols/http';
import {
	PostAccessManagementPermissions,
	PostAccessManagementPermissionsModel,
	PostAccessManagementPermissionsParams,
} from 'domain/usecases/private/profile/post-access-management-permissions';

export class RemotePostAccessManagementPermissions implements PostAccessManagementPermissions {
	constructor(
		private readonly url: string,
		private readonly httpClient: HttpClient<PostAccessManagementPermissionsModel>,
	) {}

	async post(
		params: PostAccessManagementPermissionsParams,
	): Promise<PostAccessManagementPermissionsModel> {
		const httpResponse = await this.httpClient.request({
			url: this.url,
			method: 'post',
			body: params,
		});

		switch (httpResponse.status) {
			case HttpStatusCode.ok:
				return httpResponse.data;
			case HttpStatusCode.created:
				return httpResponse.data;
			case HttpStatusCode.noContent:
				return httpResponse.data;
			default:
				throw new APIError(httpResponse.status, httpResponse.data);
		}
	}
}
